module.exports = __webpack_public_path__ + "media/public/img/google-round-01-4c7ae292eccd65b64cc32667544fd5c1.svg";